import { Card, Group, Text, Title, useMantineTheme } from '@mantine/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { STATISTICS_STATUS_COLOR_ENUM } from '../../api_enums/STATISTICS_STATUS_ENUM';

function ResourceLegend() {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  const legendItems = Object.keys(STATISTICS_STATUS_COLOR_ENUM).map(
    (status) => ({
      color: STATISTICS_STATUS_COLOR_ENUM[status],
      label: t(`StatisticsHelp.${status}`) || 'Unknown Status',
    }),
  );

  return (
    <Card withBorder p="md" radius="md">
      <Title order={2} size={theme.fontSizes.lg}>
        {t('StatisticsHelp.Legend')}
      </Title>
      <Group spacing="sm">
        {legendItems.map(({ color, label }) => (
          <Group key={label} spacing="xs" align={'center'}>
            <div
              style={{
                width: theme.fontSizes.sm * 2,
                height: theme.fontSizes.sm,
                backgroundColor: color,
              }}
            />
            <Text size="sm">{label}</Text>
          </Group>
        ))}
      </Group>
    </Card>
  );
}

export default ResourceLegend;
